// Reducer/companyReducer/companyReducer.js
const companyInitialState = {
  currentCompany: null,
  error: null
};

const CompanyReducer = (state = companyInitialState, action) => {
  switch (action.type) {
    case 'GET_COMPANY_SUCCESS':
      return { ...state, currentCompany: action.payload, error: null };
    case 'GET_COMPANY_FAILURE':
      return { ...state, error: action.payload };
    case 'UPDATE_COMPANY_LOGO':
      return {
        ...state,
        currentCompany: state.currentCompany
          ? { ...state.currentCompany, logo_url: action.payload }
          : state.currentCompany
      };
    default:
      return state;
  }
};

export default CompanyReducer;